import * as actions from "../action.constants";

const requestDashboardData = () => ({
  type: actions.REQUEST_CARD_DATA,
});

export {requestDashboardData};
